import { GetAllGroupsAPI } from "../../services/api/group-api"
import { GroupActionTypes } from "./group-types"

export const fetchGroupsStart = () => ({
  type: GroupActionTypes.FETCH_GROUPS_START
})

export const fetchGroupsFailure = () => ({
  type: GroupActionTypes.FETCH_GROUPS_FAILURE
})

export const fetchGroupsSuccess = (payload) => ({
  type: GroupActionTypes.FETCH_GROUPS_SUCCESS,
  payload: payload
})

export const setGroupsOnPage = (usersOnPage) => ({
  type: GroupActionTypes.SET_GROUPS_ON_PAGE,
  payload: usersOnPage

})

export const fetchGroups = (searchQuery) => {
  return async dispatch => {
      try {
          dispatch(fetchGroupsStart()); //starting the loading process
          
          const allGroups = await GetAllGroupsAPI(searchQuery);
          let payload = [allGroups.data.dataList, allGroups.data.totalCount];
          
          dispatch(fetchGroupsSuccess(payload)); 
          dispatch(setSearchGroupsQuery(searchQuery));
          dispatch(setGroupsOnPage(allGroups.data.dataList))

          return allGroups.data.dataList;
      }
      catch (error) {
          dispatch(fetchGroupsFailure())
          console.log(error);
      }  
  }
}

export const setSearchGroupsQuery = (searchQuery) => ({
  type: GroupActionTypes.SET_SEARCH_GROUPS_QUERY,
  payload: searchQuery
})

export const addSelectedGroup = (id) => ({
  type: GroupActionTypes.ADD_SELECTED_GROUP,
  payload: id
})

export const deleteSelectedGroup = (id) => ({
  type: GroupActionTypes.DELETE_SELECTED_GROUP,
  payload: id
})

export const setSelectedGroups = (idList) => ({
  type: GroupActionTypes.SET_SELECTED_GROUP,
  payload: idList
})